<template>
  <div class="dropdown" style="float:left;">
    <button class="dropbtn attendance-dropdown">
      <p>
        <span v-text="roles[type]" v-if="roles[type]"></span>
        <span v-else>All roles</span>
        &nbsp;<i class="fas fa-caret-down"></i>
      </p>
    </button>
    <div class="dropdown-content">
      <a href="#" @click="filter(null)">All roles</a>
      <a href="#" v-for="(role, key) in roles" :key="key" @click="filter(key)">{{ role }}</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RoleFilter',
    props: {
      type: {
        default: null
      }
    },
    computed: {
      roles() {
        return this.$store.state.settings.data.user_types;
      },
    },
    methods: {
      filter(value) {
        this.$emit('role', value);
      }
    }
  }
</script>
